// extracted by mini-css-extract-plugin
export var container = "TrackingNumber_container__RLjVi";
export var externalTrackingLinkContainer = "TrackingNumber_externalTrackingLinkContainer__8BxKG";
export var noCarrierImage = "TrackingNumber_noCarrierImage__NmaLg";
export var trackingCarrier = "TrackingNumber_trackingCarrier__BXrTt";
export var trackingCopyButton = "TrackingNumber_trackingCopyButton__bFybp";
export var trackingNumber = "TrackingNumber_trackingNumber__a9i6P";
export var trackingNumberContainer = "TrackingNumber_trackingNumberContainer__suYzL";
export var trackingNumberTitle = "TrackingNumber_trackingNumberTitle__upLu6";